<script>
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn
} from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from '/src/config/client';

export default {
  name: "WelcomePanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn
  },

  data() {
    return {
      clientConfig
    }
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ipApp");
      this.triggerHeightCheck();
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    }
  }
};
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0 pt-2 pb-2 welcome-banner">
      <MDBCol 
        col="12" 
        class="p-2 pt-5 pb-5" 
        v-html="clientConfig.content.welcome.bannerHeading"
        v-if="!clientConfig.content.welcome.alternateHeadingPosition"
      >
      </MDBCol>
    </MDBRow>
    <MDBRow class="p-0">
      <MDBCol 
        col="12" 
        class="p-2 pt-4 px-5 pb-4 text-left"
      >
        <div v-html="clientConfig.content.welcome.bannerHeading" v-if="clientConfig.content.welcome.alternateHeadingPosition"></div>
        <div v-html="clientConfig.content.welcome.header"></div>
        <div v-html="clientConfig.content.welcome.content"></div>
        <MDBBtn 
          color="primary" 
          class="rounded" 
          @click="clickToTab(2)"
          aria-label="Continue button"
        >
          {{ clientConfig.content.welcome.buttonLabel }}
          <i class="fas icon-arrow"></i>
        </MDBBtn>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>